module.exports = __webpack_public_path__ + "static/media/banner4_dark.80894349.png";